


















































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeLabSupervisi } from "@/store/modules/LabSupervisiStore";
import LabSupervisiSvc from "@/services/LabSupervisiService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import LabSeksiChecklist from "./LabSeksiChecklist.vue";

@Component({
  components: { LabSeksiChecklist }
})
export default class LabSupervisiDetail extends Vue {
  @Prop({ required: true }) sessionData!: any;

  storeModule = storeLabSupervisi;
  session: any = null;
  loading = false;
  showAckDialog = false;
  ackPassword = "";
  acknowledging = false;

  seksiList = [
    { seksi: "pengelolaan_limbah", label: "I. Supervisi Pengelolaan Limbah" },
    { seksi: "fasilitas_kebersihan", label: "II. Supervisi Fasilitas dan Kebersihan" },
    { seksi: "kepatuhan_petugas", label: "III. Kepatuhan Petugas dalam Hand Hygiene dan Penggunaan APD" },
  ];

  async mounted() {
    this.loading = true;
    await this.storeModule.loadDetail(this.sessionData.id);
    this.session = this.storeModule.currentSession;
    this.loading = false;
  }

  get scoreColor() {
    if (!this.session) return "";
    const s = this.session.compliance_score;
    if (s >= 80) return "green--text";
    if (s >= 60) return "orange--text";
    return "red--text";
  }

  /** Sesi lama masih menyimpan jawaban ya/tidak — skor legacy tetap dirender. */
  get hasLegacyHasil(): boolean {
    if (!this.session?.items) return false;
    return this.session.items.some(
      (i: any) => i.hasil !== null && i.hasil !== undefined && i.hasil !== ""
    );
  }

  getItemsBySeksi(seksi: string) {
    if (!this.session?.items) return [];
    return this.session.items
      .filter((i: any) => i.definition?.seksi === seksi)
      .sort((a: any, b: any) => (a.definition?.urutan || 0) - (b.definition?.urutan || 0))
      .map((i: any) => ({
        definition_id: i.definition_id,
        kode_item: i.definition?.kode_item,
        seksi: i.definition?.seksi,
        urutan: i.definition?.urutan,
        komponen_supervisi: i.definition?.komponen_supervisi,
        tipe_jawaban: i.definition?.tipe_jawaban,
        nilai_target_min: i.definition?.nilai_target_min,
        nilai_target_max: i.definition?.nilai_target_max,
        kritikal: i.definition?.kritikal,
        display_no: this.getDisplayNo(i.definition),
        hasil: i.hasil,
        nilai_numeric: i.nilai_numeric,
        masalah: i.masalah || "",
        rekomendasi: i.rekomendasi || "",
        foto_bukti: i.foto_bukti || [],
      }));
  }

  getDisplayNo(def: any) {
    if (!def) return "";
    const kode = def.kode_item || "";
    const parts = kode.split("-");
    return parts[parts.length - 1] || "";
  }

  unitLabLabel(val: string) {
    const map: Record<string, string> = {
      patologi_klinik: "Patologi Klinik",
      patologi_anatomi: "Patologi Anatomi",
      mikrobiologi: "Mikrobiologi",
      bank_darah: "Bank Darah",
    };
    return map[val] || val || "Seluruh Instalasi";
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD MMMM YYYY") : "-";
  }

  formatDateTime(dt: string) {
    return dt ? moment(dt).format("DD-MM-YYYY HH:mm") : "-";
  }

  printPdf() {
    if (this.session?.id) {
      LabSupervisiSvc.printPdf(this.session.id);
    }
  }

  async doAcknowledge() {
    if (!this.ackPassword) {
      appModule.NoticeDelay("Password wajib diisi");
      return;
    }
    this.acknowledging = true;
    try {
      const resp = await LabSupervisiSvc.acknowledge(this.session.id, {
        password: this.ackPassword,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil acknowledge supervisi");
        this.showAckDialog = false;
        this.ackPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.acknowledging = false;
  }
}
